var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rating",class:_vm.ratingClasses},_vm._l((_vm.maxRating),function(i,index){return _c('i',{key:index,staticClass:"rating__icon icon-star-rating",class:i > Math.round(_vm.rate) ? 'rating__icon--dis' : '',style:({
      fontSize: `${_vm.size}px`,
    })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }